import useInstitutionsByUser from "@/hooks/data/useInstitutionsByUser";
import { createContext } from "react"

export interface IInstitutionsContext extends ReturnType<typeof useInstitutionsByUser> {
}

export const InstitutionsContext = createContext<IInstitutionsContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default InstitutionsContext;